<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="administrators"
            :items="tableData"
            :fields="internshipFields">
            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-open remove-icon-margin"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.open')"
                        @click="openInternship(data.item.internship)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-internship-tag"
                        v-b-tooltip.hover
                        :title="$t('common.delete')"
                        variant="danger-icon-only"
                        @click="removeInternship(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-internships-personal-modal-component
            @accepted="acceptInternship($event)"
            ref="personal-internship-modal">
        </design-2021-internships-personal-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internships-index-personal-tab-component',
    props: ['internshipsIn'],
    data() {
        return {
            internships: this.internshipsIn,
            internshipFields: [
                {
                    key: 'owner',
                    label: this.$t('internship.name_student'),
                },
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'location',
                    label: this.$t('common.location'),
                },
                {
                    key: 'accepted',
                    label: this.$t('internship.accepted'),
                },
                {
                    key: 'tag',
                    label: this.$t('internship.internship_type'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.internshipsIn.map((internship) => {
                return {
                    id: internship.id,
                    internship: internship,
                    name: internship.name,
                    location: internship.location,
                    accepted: internship.accepted,
                    owner: internship.internship_ownerable.full_name,
                    tag: internship.internship_tags[0] ? internship.internship_tags[0].name : null,
                };
            });
        },
    },
    methods: {
        openInternship(internship) {
            this.$refs['personal-internship-modal'].show(internship);
        },
        removeInternship(id) {
            this.alert
                .confirm(
                    this.$t('internship.delete_personal_internship'),
                    this.$t('internship.are_you_sure_you_want_to_delete_this_personal_internship'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.axios.delete(this.routes.internshipDelete(id)).then(
                        (response) => {
                            this.alert.success();
                            this.$emit('deleteInternship', id);
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        acceptInternship(internship) {
            this.$emit('acceptInternship', internship);
        },
    },
};
</script>

<style scoped></style>
